import { Feather } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from 'react-intl';
import {
    Dimensions,
    Text,
    TouchableOpacity,
    View,
} from "react-native";
import NumberInput from "../../components/NumberInput";
import ScreenLoader from "../../components/ScreenLoader";
import api from "../../services/api";


import HeaderDefault from "../../components/HeaderDefault";

import HeaderInfoCoin from "../../components/HeaderInfoCoin";
import styles from "./styles";

import balanceService from "../../services/balanceService";
import { formatGPXBalance, maxDecimals } from "../../utils/formatNumber";


const DetailsCoin = ({ navigation }) => {
    const [qtd, setQtd] = useState(1);
    const [dataToken, setDataToken] = useState([]);
    const [active, setActive] = useState();
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [infosToken, setInfosToken] = useState([]);
    const [dataGraphic, setDataGraphic] = useState([0, 0, 0, 0, 0, 0]);
    const [dateGraphic, setDateGraphic] = useState([
        "00/00",
        "00/00",
        "00/00",
        "00/00",
        "00/00",
        "00/00",
        "00/00",
    ]);

    const [balance, setBalance] = useState(0);
    const [percent, setPercent] = useState(0);

    const screenWidth = Dimensions.get("window").width;

    useEffect(() => {
        getDataToken();
        getData();
        loadBalance();
    }, []);

    const getDataToken = async () => {
        const authToken = await AsyncStorage.getItem("JWT_TOKEN");
        const idToken = await AsyncStorage.getItem("id_token");
        setLoading1(true)
        api
            .get(`/actives/${idToken}`, {
                headers: { Authorization: `Bearer ${authToken}` },
            })
            .then((res) => {
                setDataToken(res.data);
                if (res.data.actives.length > 0) {
                    setActive(res.data.actives[0]);
                }
                setLoading1(false)
            })
            .catch((error) => {
                setLoading1(false)
                console.log(error);
            });
    };

    const getData = async () => {
        const authToken = await AsyncStorage.getItem("JWT_TOKEN");
        const idToken = await AsyncStorage.getItem("id_token");
        setLoading2(true)
        api
            .get(`/marketplace-moviments/${idToken}`, {
                headers: { Authorization: `Bearer ${authToken}` },
            })
            .then((res) => {
                setInfosToken(res.data);
                //console.log(res.data.lastPrice.purchase_quantity_brl);
                setDataGraphic(res.data.graphic);

                var dates = [];

                var i = 8;
                while (true) {
                    i--;
                    const date = new Date();
                    date.setDate(date.getDate() - i);
                    var dayNow = date.getDate();
                    var month = date.getMonth();

                    var monthFormat = month < 10 ? `0${month}` : month;

                    var daysFormat =
                        dayNow < 10
                            ? `0${dayNow}/${monthFormat}`
                            : `${dayNow}/${monthFormat}`;
                    dates.push(daysFormat);
                    if (i === 1) {
                        break;
                    }
                }
                setLoading2(false)
                setDateGraphic(dates);
            })
            .catch((error) => {
                setLoading2(false)
                console.log(error);
            });
    };

    const handleBuyToken = async () => {
        // navigation.navigate("ConfirmPurchaseOrSell", { qtd: qtd, token: active.id, viewType: 'buy', market: false });
        navigation.navigate("ConfirmPurchaseOrSell", { qtd: qtd, token: active.id, viewType: 'buy' });
    };

    const getTokenValue = () => {
        return (dataToken?.actives?.length > 0 ? dataToken?.actives[0].single_value : 0)
    }

    const getMoreInfo = async () => {
        await AsyncStorage.setItem('id_coin', active.id + '');
        navigation.navigate("MoreInfosCoin")
    }

    const calcAmountByPercent = () => {
        let calc = qtd;
        if(!(dataToken?.actives?.length) || dataToken?.actives?.length === 0) {
          return;
        }
        console.log(qtd);
        console.log(dataToken?.actives[0].cryptoactive);
        if(dataToken?.actives?.length && dataToken?.actives[0].cryptoactive) {
          calc = maxDecimals(Math.ceil(balance/getTokenValue())*(percent/100), 8);
        }else{
          // 10 custo tenho 50 -> quero usar 10% saldo -> saldo/custo*percentual
          calc = (Math.floor((balance/getTokenValue())*(percent/100)));
          if(calc === 0) {
              calc = 1;
          }
          if(calc < 1) {
              calc = 0;
          }
        }
        setQtd(calc+'');
      }
    
      const loadBalance = async () => {
        const authToken = await AsyncStorage.getItem("JWT_TOKEN");
        balanceService.getBalanceOfGpx(authToken).then((response) => {
          if (response?.data?.balance?.length > 0) {
              setBalance(response?.data?.balance[0].saldo + '');
          }
        }).catch((error) => { });
      }
    

    return (
        <>
            <ScreenLoader loading={loading1 || loading2} />
            <HeaderDefault title={<FormattedMessage id="detailsCoin.headerMarketplace"/>} />

            <View style={styles.container}>
                {/* <HeaderInfoToken dataToken={dataToken} /> */}

                <HeaderInfoCoin dataCoin={dataToken} />
                <View style={styles.hrLine}></View>
                <TouchableOpacity
                    style={styles.contentMore}
                    onPress={() => getMoreInfo()}
                >
                    <Text style={styles.textMore}><FormattedMessage id="detailsCoin.maisInformacoes"/></Text>
                    <Feather name="arrow-right" size={24} color="#1F26BF" />
                </TouchableOpacity>

                {/* <View>
          <LineChart
            data={{
              labels: dateGraphic,
              datasets: [
                {
                  data: dataGraphic,
                },
              ],
            }}
            width={screenWidth} // from react-native
            height={220}
            withHorizontalLabels={false}
            chartConfig={{
              backgroundGradientFromOpacity: 0,
              backgroundGradientToOpacity: 0,
              decimalPlaces: 2, // optional, defaults to 2dp
              color: (opacity = 0.1) => `rgba(244, 156, 22, ${opacity})`,
              labelColor: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
              style: {
                borderRadius: 16,
              },
              propsForDots: {
                r: "7",
                strokeWidth: "2",
                stroke: "#ffa726",
              },
            }}
            bezier
            style={{
              marginVertical: 8,
              borderRadius: 16,
              marginLeft: -34,
            }}
          />

          
          </View> */}

                <View style={{ marginTop: 15, marginBottom: 15 }}>
                    {/* <LineChartByActive price={active?.single_value || 0.00} /> */}
                </View>

                {/* <View style={styles.contentTitleBottomLine}>
                    {/* <Text style={styles.nameTitleBottomLine}>VARIAÇÃO</Text>}
                    <Text style={styles.nameTitleBottomLine}>ÚLTIMA</Text>
                    <Text style={styles.nameTitleBottomLine}>MENOR</Text>
                    <Text style={styles.nameTitleBottomLine}>MAIOR</Text>
                    <Text style={styles.nameTitleBottomLine}>VOLUME EM 24H</Text>
                </View>

                <View style={styles.contentInfoBottomLine}>
                    {/* <Text style={styles.InfoBottomLineVariation}>+2,37%</Text>}

                    <Text style={styles.InfoBottomLine}>R$ {infosToken.maxPrice}</Text>
                    <Text style={styles.InfoBottomLine}>R$ {infosToken.minPrice}</Text>
                    <Text style={styles.InfoBottomLine}>R$ {infosToken.maxPrice}</Text>
                    <Text style={styles.InfoBottomLine}>{parseFloat(infosToken.lastHours + '')} {dataToken?.actives?.length > 0 && dataToken?.actives[0].name_token}</Text>
                </View> */}

                <View style={styles.hrLine}></View>
            </View>
            <View style={styles.contentPurchase}>
                <Text style={styles.titlePurchase}>
                <FormattedMessage id="detailsCoin.quantoDeseja"/>
                </Text>
                <View style={styles.contentPurchaseAmount}>
                    <NumberInput value={qtd} onChange={value => setQtd(value)}
                    />
                </View>
                <View style={{ alignItems: 'center' }}>
                    <Text style={{ color: '#656565', paddingTop: 5 }}>{qtd > 0 && getTokenValue() > 0 && (formatGPXBalance(qtd * getTokenValue()) + ' GPX/BRL')}</Text>
                </View>
            </View>

            {/* <View style={styles.sliderContainer}>
                {
                    (!isNaN(qtd) && !isNaN(getTokenValue())) 
                    && <Slider
                        minimumValue={0}
                        maximumValue={100}
                        step={25}
                        onValueChange={percentUpdate => {
                            // calcAmountByPercent();
                            // calcPercentByAmount()
                            // setPercent(percentUpdate);
                            setAmount(percentUpdate)
                            console.log(price)
                        }}
                        value={amount}
                        // knobColor='#00490C'
                        // valueLabelsBackgroundColor='#196059'
                        // inRangeBarColor='#656565'
                        // outOfRangeBarColor='#196059'
                    />
                }
            </View>

            <View style={{ alignItems: 'center', marginTop: -35, marginBottom: 25 }}>
                <Text style={{ color: '#656565', paddingTop: 5 }}>{(!isNaN(percent) && Math.round(percent))}% do saldo</Text>
            </View> */}


            <View style={styles.contentBtn}>
                <TouchableOpacity
                    disabled={qtd <= 0 ? true : false}
                    onPress={() => handleBuyToken(dataToken)}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#196059", "#196059"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}><FormattedMessage id="detailsCoin.btnComprar"/></Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
};

export default DetailsCoin;
